/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Voice_Type_FilterInputs */

const en_mobile_voice_type_filter = /** @type {(inputs: Mobile_Voice_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice type`)
};

const es_mobile_voice_type_filter = /** @type {(inputs: Mobile_Voice_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de voz`)
};

/**
* | output |
* | --- |
* | "Voice type" |
*
* @param {Mobile_Voice_Type_FilterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_voice_type_filter = /** @type {((inputs?: Mobile_Voice_Type_FilterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Voice_Type_FilterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_voice_type_filter(inputs)
	return en_mobile_voice_type_filter(inputs)
});